import React, { useEffect, useState, useRef } from "react";
import IntlMessages from "util/IntlMessages";
import AdminNotifications from "components/AdminNotifications";
import AssignComplianceTemplateModal from "components/AssignComplianceTemplateModal";
import {
  Card,
  Table,
  Row,
  Col,
  Button,
  Tooltip,
  Modal,
  Space,
  Input,
  Popover,
  Checkbox,
  Menu,
  Dropdown,
  Badge,
  Divider,
  Typography,
  Select,
} from "antd";
import chatIcon from "assets/images/icons/chat.svg";
import downloadIcon from "assets/images/icons/arrow_circle_down.svg";
import rejectIcon from "assets/images/icons/block.svg";
import templateIcon from "assets/images/icons/chat_paste_go.svg";
import verifyIcon from "assets/images/icons/check.svg";
import deleteTempIcon from "assets/images/icons/delete.svg";
import downloadFileIcon from "assets/images/icons/file_save.svg";
import notificationIcon from "assets/images/icons/notifications.svg";
import commentIcon from "assets/images/icons/comment.svg";
import ATIcon from "assets/images/icons/assignment_add.svg";
import notificationBellIcon from "assets/images/icons/notification.svg";
import SearchOutlinedIcon from "assets/images/icons/search_outlined.svg";
import SearchFilledIcon from "assets/images/icons/search_filled.svg";
import "./partner-complaince.css";
import CustomPagination from "../../../components/CustomPagination";
import ConfirmationPopup from "../../../components/ConfirmationPopup";
import { useConfirmationPopup } from "../../../hooks/useConfirmationPopup";

import {
  MessageOutlined,
  SearchOutlined,
  EllipsisOutlined,
} from "@ant-design/icons";
import {
  useGetPartnerComplianceListQuery,
  useSendComplianceReminderMutation,
  useSendComplianceMailMutation,
  useDownloadTemplateMutation,
  useDownloadSignedTemplateMutation,
  useVerifySignedLetterMutation,
  useRejectSignedLetterMutation,
  useDeletePartnerTemplateMutation,
  useSendBulkReminderMutation,
  useGetNotificationsQuery,
  useMarkNotificationsReadMutation,
} from "../../../appRedux/api/complianceApi";
import {
  showConfirm,
  getRole,
  showMessage,
  getUserInfo,
} from "../../../helpers";
import { getEmailTemplate, putEmailTemplate } from "../../../services";
import Chats from "../chats";
// import { useNavigate } from "react-router-dom"; // REMOVED
import LoadingBar from "../../../components/LoadingBar";
const { TextArea } = Input;

const CustomFilterDropdown = ({
  options,
  selectedKeys,
  setSelectedKeys,
  confirm,
  clearFilters,
  placeholder = "Search..."
}) => (
  <div style={{ padding: 8, width: 240 }}>
    <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
      <Select
        mode="multiple"
        placeholder={placeholder}
        value={selectedKeys}
        onChange={setSelectedKeys}
        showSearch
        style={{
          width: '100%',
          minHeight: 20,
          marginBottom: 0,
          display: 'block'
        }}
        filterOption={(input, option) =>
          option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        maxTagCount="responsive"
        allowClear={false}
        dropdownRender={menu => (
          <>
            {menu}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: 8,
              padding: '0 8px'
            }}>
              <Button
                size="small"
                onClick={() => {
                  clearFilters && clearFilters();
                  confirm && confirm();
                }}
                style={{ flex: 1 }}
              >
                Reset
              </Button>
              <Button
                type="primary"
                size="small"
                onClick={() => confirm && confirm()}
                style={{ flex: 1 }}
              >
                Apply
              </Button>
            </div>
          </>
        )}
      >
        {options.map(option => (
          <Select.Option key={option} value={option}>
            {option}
          </Select.Option>
        ))}
      </Select>
    </div>
    <div style={{ display: "flex", justifyContent: "space-between", marginTop: 8 }}>
      <Button
        size="small"
        style={{ flex: 1 }}
        onClick={() => {
          clearFilters && clearFilters();
          confirm && confirm();
        }}
      >
        Reset
      </Button>
      <Button
        type="primary"
        size="small"
        style={{ flex: 1 }}
        onClick={() => confirm && confirm()}
      >
        Apply
      </Button>
    </div>
  </div>
);

const PartnerCompliance = (props) => {
  // const navigate = useNavigate(); // REMOVED

  // Request parameters state
  const [requestObj, setRequestObj] = useState({
    offset: 0,
    limit: 10,
  });
  const [currentPage, setCurrentPage] = useState(1); // Track current page
  const [currentQuarter, setCurrentQuarter] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [tempFilterValue, setTempFilterValue] = useState("");
  const [verficationStatus, setVerficationStatus] = useState("");
  const [tempVerficationStatus, setTempVerficationStatus] = useState("");
  const [tableSearch, setTableSearch] = useState({});
  const [totalCount, setTotalCount] = useState(0);
  const [yearOptions, setYearOptions] = useState([]);

  // Add these states for search/filter persistence
  const [filterStates, setFilterStates] = useState({
    name: { searchText: '', searchedColumn: '' },
    email: { searchText: '', searchedColumn: '' },
    template_name: { searchText: '', searchedColumn: '' },
  });
  const [statusFilter, setStatusFilter] = useState('');
  const [verificationStatusFilter, setVerificationStatusFilter] = useState('');

  // Add temp states for dropdown filter selections - REMOVED: No longer needed with CustomFilterDropdown

  // ADDED: State for assign template modal
  const [isAssignTemplateModalOpen, setIsAssignTemplateModalOpen] = useState(false);

  // RTK Query hooks
  const { data: partnerComplianceData, isLoading, isFetching } =
    useGetPartnerComplianceListQuery({
      ...requestObj,
      quarter: currentQuarter || undefined,
      company_name: filterStates.name.searchText || undefined,
      email: filterStates.email.searchText || undefined,
      template_filter: filterStates.template_name.searchText || undefined,
      status: statusFilter || undefined,
      verification_status: verificationStatusFilter || undefined,
    });

  const { data: notifications = { count: 0, items: [] } } =
    useGetNotificationsQuery();
  const [markNotificationsRead] = useMarkNotificationsReadMutation();
  const [sendComplianceReminder] = useSendComplianceReminderMutation();
  const [sendComplianceMail] = useSendComplianceMailMutation();
  const [downloadTemplate] = useDownloadTemplateMutation();
  const [downloadSignedTemplate] = useDownloadSignedTemplateMutation();
  const [verifySignedLetter] = useVerifySignedLetterMutation();
  const [rejectSignedLetter] = useRejectSignedLetterMutation();
  const [deleteAssignedTemplate] = useDeletePartnerTemplateMutation();
  const [sendBulkReminder] = useSendBulkReminderMutation();

  // Component state
  const [notificationCount, setNotificationCount] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);
  const [emailData, setEmailData] = useState({
    subject: "",
    body1: "",
  });
  const [partner, setPartner] = useState();
  const [isUserAdmin, setIsUserAdmin] = useState(false);
  const [isUserLegal, setIsUserLegal] = useState(false);
  const [isUserPartner, setIsUserPartner] = useState(false);
  const [data, setData] = useState([]);
  const [recordTotal, setRecordTotal] = useState(0);
  const [quarterDropdown, setQuarterDropdown] = useState([]);
  const [currentYear, setCurrentYear] = useState(null);
  const [userDetails, setUserDetails] = useState({});
  const [searchedColumn, setSearchedColumn] = useState();
  const [selectedYear, setSelectedYear] = useState(null);

  // Confirmation popup state
  const {
    isVisible: confirmationVisible,
    config: confirmationConfig,
    handleConfirm,
    handleCancel: handleConfirmationCancel,
    showSendReminderConfirmation,
    showSendTemplateConfirmation,
    showDownloadConfirmation,
    showDownloadSignedConfirmation,
    showVerifyConfirmation,
    showRejectConfirmation,
    showDeleteConfirmation,
    showBulkReminderConfirmation,
  } = useConfirmationPopup();

  // Show loading either during initial load or when fetching during pagination
  const isTableLoading = isLoading || isFetching;

  useEffect(() => {
    setNotificationCount(notifications.count);
  }, [notifications]);

  useEffect(() => {
    setUserDetails(getUserInfo());
    setIsUserAdmin(() => {
      return getRole() === "ADMIN";
    });
    setIsUserLegal(() => {
      return getRole() === "LEGAL";
    });
    setIsUserPartner(() => {
      return getRole() === "PARTNER";
    });
  }, []);

  const getFinalPartnerComplianceList = (partnerComplianceArray) => {
    let data = [];

    if (!partnerComplianceArray || !Array.isArray(partnerComplianceArray)) {
      return data;
    }

    partnerComplianceArray.forEach((val) => {
      if (val.html_templates_assigned && Array.isArray(val.html_templates_assigned) && val.html_templates_assigned.length > 0) {
        val.html_templates_assigned.forEach((template) => {
          data.push({
            key: `${val.partner_id}-${template.template_id}`,
            partner_id: val.partner_id,
            name: val.company_name,
            email: val.email,
            template_name: template.template_name,
            status: template.status,
            template_history_id: template.template_history_id,
            template_assigned: true,
            download_status: template.download_status,
            reminder_status: template.reminder_status,
            template_id: template.template_id,
            verification_status: template.verification_status || "-",
            quarter_year: parseInt(val.quarter_year, 10),
            is_approved: template.is_approved
          });
        });
      } else {
        data.push({
          key: val.partner_id,
          partner_id: val.partner_id,
          name: val.company_name,
          email: val.email,
          template_name: "Not Assigned",
          status: "N/A",
          template_assigned: false,
          verification_status: "-",
          quarter_year: parseInt(val.quarter_year, 10),
          is_approved: false
        });
      }
    });

    return data;
  };

  const mergeCell = (data) => {
    if (!data || !Array.isArray(data)) return [];

    const emailCounts = data.reduce((acc, item) => {
      acc[item.email] = (acc[item.email] || 0) + 1;
      return acc;
    }, {});

    return data.map((item, index) => {
      const previousItems = data.slice(0, index);
      const isFirstOccurrence = !previousItems.find(prev => prev.email === item.email);

      return {
        ...item,
        rowSpan: isFirstOccurrence ? emailCounts[item.email] : 0
      };
    });
  };

  useEffect(() => {
    if (!partnerComplianceData) return;

    try {
      const partnercomplianceData = partnerComplianceData.results || [];
      const totalRecords = partnerComplianceData.count || 0;
      const processedData = getFinalPartnerComplianceList(partnercomplianceData);

      setData(processedData);
      setTotalCount(totalRecords);
      setRecordTotal(totalRecords);

      // Extract and sort years from backend
      const availableYears = (partnerComplianceData.filters?.year || [])
        .map(y => y.quarter_year)
        .filter(Boolean)
        .sort((a, b) => b - a); // Sort descending (newest first)

      setYearOptions(availableYears);

      // Set current year - prioritize backend's current_year, then first available year
      const backendCurrentYear = partnerComplianceData.current_year;
      const initialYear = backendCurrentYear ?? availableYears[0] ?? null;

      if (initialYear !== null) {
        setCurrentYear(initialYear);
        // Only update selectedYear if it's not already set to avoid unnecessary re-renders
        if (selectedYear === null) {
          setSelectedYear(initialYear);
        }
      }
    } catch (error) {
      console.error("Error processing partner compliance data:", error);
      setData([]);
      setTotalCount(0);
      setRecordTotal(0);
    }
  }, [partnerComplianceData]);

  // Update requestObj when year changes
  useEffect(() => {
    if (selectedYear !== null && selectedYear !== currentYear) {
      setRequestObj(prev => ({
        ...prev,
        offset: 0,
        year: selectedYear,
      }));
      setCurrentPage(1);
    }
  }, [selectedYear]);

  const handleTableChange = (pagination, filters, sorter) => {
    const { current, pageSize } = pagination;
    const validCurrent = Number(current) || 1;
    const validPageSize = Number(pageSize) || 10;
    
    setCurrentPage(validCurrent);
    setRequestObj(prev => ({
      ...prev,
      offset: (validCurrent - 1) * validPageSize,
      limit: validPageSize
    }));

    // Handle filters from CustomFilterDropdown
    if (filters) {
      // Update status filter (handle both set and reset cases)
      if (filters.status !== undefined) {
        const newStatusFilter = filters.status?.length ? filters.status.join(",") : '';
        setStatusFilter(newStatusFilter);
        // Reset pagination when filter changes
        if (current !== 1) {
          setCurrentPage(1);
          setRequestObj(prev => ({ ...prev, offset: 0 }));
        }
      }
      // Update verification status filter (handle both set and reset cases)
      if (filters.verification_status !== undefined) {
        const newVerificationFilter = filters.verification_status?.length ? filters.verification_status.join(",") : '';
        setVerificationStatusFilter(newVerificationFilter);
        // Reset pagination when filter changes
        if (current !== 1) {
          setCurrentPage(1);
          setRequestObj(prev => ({ ...prev, offset: 0 }));
        }
      }
    }
  };


  const onEmailTemplateChange = (e) => {
    if (e.target.id === "subject") {
      setEmailData({ ...emailData, subject: e.target.value });
    }
    if (e.target.id === "body1") {
      setEmailData({ ...emailData, body1: e.target.value });
    }
  };

  // REPLACED: Changed from navigation to modal opening
  const navigateToAssignTemplate = () => {
    setIsAssignTemplateModalOpen(true);
  };

  // ADDED: Success handler for template assignment
  const handleAssignTemplateSuccess = () => {
    showMessage("success", "Template assigned successfully");
    // You might want to add data refetching logic here if needed
  };

  const handleSendReminder = (item) => {
    showSendReminderConfirmation(
      item.name,
      () => {
        console.log("Send reminder confirmed");
        const sendReminderData = {
          partner_id: item.partner_id,
        };
        sendComplianceReminder(sendReminderData);
      }
    );
  };

  const showModal = (item) => {
    showSendTemplateConfirmation(
      item.name,
      () => {
        setPartner(item);
        getEmailTemplate(item.partner_id)
          .then((response) => {
            setEmailData({
              subject: response.subject,
              body1: response.body1,
            });
            setIsModalOpen(true);
          })
          .catch((err) => {
            showMessage("error", err.toString());
          });
      }
    );
  };

  const showChatModal = (item) => {
    setPartner(item);
    setChatOpen(true);
  };

  const handleOk = () => {
    putEmailTemplate(partner.partner_id, emailData)
      .then((response) => {
        if (response) {
          handleSendMail(partner);
          setIsModalOpen(false);
        }
      })
      .catch((err) => {

        showMessage("error", err.toString());
      });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleSendMail = (item) => {
    sendComplianceMail({
      id: item.partner_id,
      template_id: item.template_id,
    });
  };

  const handleDownloadTemplate = (item) => {
    showDownloadConfirmation(
      item.name,
      () => {
        const sendDownloadData = {
          template_history_id: item.template_history_id,
          templates_pdf: "true",
          signed_pdf: "false",
        };
        downloadTemplate(sendDownloadData);
      }
    );
  };

  const handleDownloadSignedTemplate = (item) => {
    showDownloadSignedConfirmation(
      item.name,
      () => {
        const sendSignedDownloadData = {
          template_history_id: item.template_history_id,
          templates_pdf: "false",
          signed_pdf: "true",
        };
        downloadSignedTemplate(sendSignedDownloadData);
      }
    );
  };

  const handleVerifySignedLetter = (item) => {
    showVerifyConfirmation(
      item.name,
      () => {
        const verifySignedData = {
          partner_id: item.partner_id,
          message: "-",
          template_history_id: item.template_history_id,
          template_id: item.template_id,
          is_approved: true,
        };
        verifySignedLetter(verifySignedData);
      }
    );
  };

  const handleRejectSignedLetter = (item) => {
    showRejectConfirmation(
      item.name,
      () => {
        const rejectSignedData = {
          partner_id: item.partner_id,
          message: "-",
          template_history_id: item.template_history_id,
          template_id: item.template_id,
          is_approved: false,
        };
        rejectSignedLetter(rejectSignedData);
      }
    );
  };

  const handleDeletePartnerTemplate = (item) => {
    showDeleteConfirmation(
      item.name,
      () => {
        const deleteData = {
          template_id: item.template_id,
          partner_id: item.partner_id,
        };
        deleteAssignedTemplate(deleteData);
      }
    );
  };

  const handleSendBulkReminder = () => {
    showBulkReminderConfirmation(
      "all partners",
      () => {
        sendBulkReminder({});
      }
    );
  };

  const changeQuarter = (e) => {
    setRequestObj(prev => ({ ...prev, offset: 0 }));
    setCurrentPage(1);
    if (e.target.value !== "0") {
      setCurrentQuarter(e.target.value);
    } else {
      setCurrentQuarter("");
    }
  };

  // Fix: When filters change, reset offset to 0 to avoid NaN
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setFilterStates(prev => ({
      ...prev,
      [dataIndex]: {
        searchText: selectedKeys[0],
        searchedColumn: dataIndex
      }
    }));
    setRequestObj((prev) => ({
      ...prev,
      offset: 0,
    }));
    setCurrentPage(1);
  };

  const handleReset = (clearFilters, dataIndex) => {
    clearFilters && clearFilters();
    setFilterStates(prev => ({
      ...prev,
      [dataIndex]: {
        searchText: '',
        searchedColumn: ''
      }
    }));
    setRequestObj((prev) => ({
      ...prev,
      offset: 0,
    }));
    setCurrentPage(1);
  };

  // Update getColumnSearchProps to use controlled values
  const getColumnSearchProps = (dataIndex, placeholder) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${placeholder}`}
          value={selectedKeys[0] || ''}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters, dataIndex)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
      filterIcon: filtered => (
        filtered
          ? <img src={SearchFilledIcon} alt="Search Filled" style={{ width: 16, height: 16 }} />
          : <img src={SearchOutlinedIcon} alt="Search Outlined" style={{ width: 16, height: 16 }} />
      ),
    filteredValue: filterStates[dataIndex]?.searchedColumn === dataIndex ? [filterStates[dataIndex]?.searchText] : [],
  });


  // REMOVED: onSetFilter and onSetVerificationStatus - no longer needed with CustomFilterDropdown

  // REMOVED: Old status filter handlers - no longer needed with CustomFilterDropdown

  // REMOVED: Old verification status filter handlers - no longer needed with CustomFilterDropdown

  // REMOVED: useEffect hooks for syncing temp states - no longer needed with CustomFilterDropdown

  const columns = [
    {
      title: "Company Name",
      dataIndex: "name",
      key: "name",
      align: "center",
      ...getColumnSearchProps("name", "Company Name"),
      render(_, row) {
        return {
          children: row.name,
          props: {
            rowSpan: row.rowSpan,
          },
        };
      },
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      align: "center",
      width: "300px",
      ...getColumnSearchProps("email", "Email"),
      render(_, row) {
        return {
          children: row.email,
          props: {
            rowSpan: row.rowSpan,
          },
        };
      },
    },
    {
      title: "Templates Assigned",
      children: [
        {
          title: "Name",
          dataIndex: "template_name",
          key: "template_name",
          align: "center",
          ...getColumnSearchProps("template_name", "Name"),
        },
        {
          title: "Status",
          dataIndex: "status",
          key: "status",
          align: "center",
          filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <CustomFilterDropdown
              options={["Received", "Sent", "Not Sent"]}
              selectedKeys={selectedKeys}
              setSelectedKeys={setSelectedKeys}
              confirm={confirm}
              clearFilters={clearFilters}
              placeholder="Select status..."
            />
          ),
          filteredValue: statusFilter ? statusFilter.split(",") : [],
        },
        {
          title: "Verification Status",
          dataIndex: "verification_status",
          key: "verification_status",
          align: "center",
          filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <CustomFilterDropdown
              options={["Verified", "Rejected"]}
              selectedKeys={selectedKeys}
              setSelectedKeys={setSelectedKeys}
              confirm={confirm}
              clearFilters={clearFilters}
              placeholder="Select verification status..."
            />
          ),
          filteredValue: verificationStatusFilter ? verificationStatusFilter.split(",") : [],
        },
      ],
    },
    {
      title: "Action",
      key: "operation",
      align: "center",
      width: "200px",
      render: (item) => {
        const disabledBase =
          (isUserAdmin || isUserLegal ? false : true) ||
          item.quarter_year < currentYear;

        const menu = (
          <Menu style={{ padding: "12px" }} id="partner-actions-dropdown-menu">
            <Menu.Item className="actionDropdownTitle">Actions</Menu.Item>
            {(isUserPartner || isUserAdmin) && (
              <Menu.Item
                key="chat"
                onClick={() => showChatModal(item)}
                disabled={disabledBase || !item.template_assigned}
                icon={<img src={chatIcon} alt="Chat" width={16} height={16} />}
              >
                Chats
              </Menu.Item>
            )}
            <Menu.Item
              key="send"
              onClick={() => showModal(item)}
              disabled={disabledBase || !item.template_assigned}
              icon={
                <img src={templateIcon} alt="Send" width={16} height={16} />
              }
            >
              Send Template
            </Menu.Item>
            <Menu.Item
              key="reminder"
              onClick={() => handleSendReminder(item)}
              disabled={disabledBase || !item.reminder_status}
              icon={
                <img
                  src={notificationIcon}
                  alt="Reminder"
                  width={16}
                  height={16}
                />
              }
            >
              Send Reminder
            </Menu.Item>
            <Menu.Item
              key="download"
              onClick={() => handleDownloadTemplate(item)}
              disabled={
                disabledBase || !item.reminder_status || !item.template_assigned
              }
              icon={
                <img src={downloadIcon} alt="Download" width={16} height={16} />
              }
            >
              Download
            </Menu.Item>
            <Menu.Item
              key="signed"
              onClick={() => handleDownloadSignedTemplate(item)}
              disabled={
                disabledBase || !item.template_assigned || !item.download_status
              }
              icon={
                <img
                  src={downloadFileIcon}
                  alt="Signed PDF"
                  width={16}
                  height={16}
                />
              }
            >
              Download Signed PDF
            </Menu.Item>
            <Menu.Item
              key="verify"
              onClick={() => handleVerifySignedLetter(item)}
              disabled={
                disabledBase || !item.template_assigned || !item.download_status
              }
              icon={
                <img src={verifyIcon} alt="Verify" width={16} height={16} />
              }
            >
              Verify
            </Menu.Item>
            <Menu.Item
              key="reject"
              onClick={() => handleRejectSignedLetter(item)}
              disabled={
                disabledBase || !item.template_assigned || !item.download_status
              }
              icon={
                <img src={rejectIcon} alt="Reject" width={16} height={16} />
              }
            >
              Reject
            </Menu.Item>
            <Menu.Item
              key="delete"
              onClick={() => handleDeletePartnerTemplate(item)}
              disabled={disabledBase || !item.template_assigned}
              icon={
                <img src={deleteTempIcon} alt="Delete" width={16} height={16} />
              }
            >
              Delete Template
            </Menu.Item>
          </Menu>
        );
        return (
          <Dropdown overlay={menu} trigger={["click"]}>
            <Button
              type="link"
              icon={<EllipsisOutlined style={{ fontSize: "20px" }} />}
            />
          </Dropdown>
        );
      },
    },
  ];

  return (
    <div className="partner-compliance-page">
      <Col span={24}>
        <div className="gx-flex-row align-items-baseline">
          <h1 className="title gx-mb-4">
            <IntlMessages id="sidebar.partner-compliance" />
          </h1>

          <Button
            id="add-product-btn"
            type="primary"
            onClick={navigateToAssignTemplate}
            disabled={isUserAdmin || isUserLegal ? false : true}
            className="gx-ml-auto"
          >
            <img
              className="icon"
              src={ATIcon}
              alt="AT"
              width={16}
              height={16}
              style={{ marginRight: "8px" }}
            />
            Assign Template
          </Button>
          {data && (
            <Button
              id="send-bulk-reminder-btn"
              type="primary"
              onClick={handleSendBulkReminder}
              disabled={isUserAdmin || isUserLegal ? false : true}
            >
              <img
                className="icon"
                src={commentIcon}
                alt="ABR"
                width={16}
                height={16}
                style={{ marginRight: "8px" }}
              />
              Send Bulk Reminder
            </Button>
          )}

          <Badge count={notificationCount}>
            <Popover
              overlayClassName="gx-popover-horizantal"
              placement="bottomRight"
              content={
                <AdminNotifications
                  isAdmin={isUserAdmin}
                  data={notifications?.read_notifications}
                  title={"Notifications"}
                  isPartnerCompliance={true}
                />
              }
              trigger="click"
            >
              <Button
                className="notificationBell"
                id="pdt-msg-box"
                style={{ margin: "3px" }}
                onClick={() => {
                  markNotificationsRead();
                  setNotificationCount(0);
                }}
              >
                <img
                  className="icon"
                  src={notificationBellIcon}
                  alt="ABR"
                  width={16}
                  height={16}
                />
              </Button>
            </Popover>
          </Badge>

          {/* Year Dropdown */}
          <Select
            style={{ width: 80, borderRadius: "6px" }}
            value={selectedYear}
            onChange={(value) => setSelectedYear(value)}
            options={yearOptions.map((year) => ({
              value: year,
              label: year,
            }))}
            placeholder="Select Year"
          />
        </div>
      </Col>
      <Modal
        title="Chats"
        centered
        visible={chatOpen}
        onCancel={() => setChatOpen(false)}
        footer={false}
        width={600}
      >
        <Chats
          heading={true}
          partner_id={partner?.partner_id}
          template_id={partner?.template_id}
          userId={userDetails.user_id}
        />
        <Divider />
        <Typography.Link
          href={`/admin/chats?template_id=${partner?.template_id}&partner_id=${partner?.partner_id}&user_id=${userDetails.user_id}`}
          target="_blank"
        >
          Full view
        </Typography.Link>
      </Modal>
      <Modal
        title="Email"
        visible={isModalOpen}
        width={600}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleOk}>
            Send
          </Button>,
        ]}
      >
        <label for="subject">Subject</label>
        <Input
          placeholder="Subject"
          id="subject"
          value={emailData.subject}
          style={{
            marginBottom: 20,
          }}
          onChange={onEmailTemplateChange}
        />
        <label for="body1">Body</label>
        <TextArea
          value={emailData.body1}
          className="my-select"
          showCount
          id="body1"
          onChange={onEmailTemplateChange}
          style={{
            height: 150,
          }}
          maxLength={500}
          placeholder="Body"
        />
      </Modal>

      {isTableLoading ? (
        <LoadingBar loading={isTableLoading} />
      ) : (
        <Table
          className="gx-table-responsive mpp-list-table"
          columns={columns}
          dataSource={mergeCell(data)}
          pagination={false}
          loading={isTableLoading}
          onChange={handleTableChange}
          bordered
          scroll={{
            y: 'calc(100vh - 250px)',
          }}
          sticky={{
            offsetHeader: 0
          }}
        />
      )}

      {/* Custom Pagination with Records per page */}
      <CustomPagination
        current={currentPage}
        total={totalCount}
        pageSize={requestObj.limit}
        showSizeChanger={true}
        pageSizeOptions={['10', '20', '50', '100']}
        onChange={(page, pageSize) => {
          const validPage = Number(page) || 1;
          const validPageSize = Number(pageSize) || 10;
          
          setCurrentPage(validPage);
          setRequestObj(prev => ({
            ...prev,
            offset: (validPage - 1) * validPageSize,
            limit: validPageSize,
          }));
        }}
        onShowSizeChange={(current, size) => {
          const validSize = Number(size) || 10;
          
          setCurrentPage(1);
          setRequestObj(prev => ({
            ...prev,
            offset: 0,
            limit: validSize,
          }));
        }}
      />

      {/* ADDED: Assign Template Modal */}
      <AssignComplianceTemplateModal
        visible={isAssignTemplateModalOpen}
        onCancel={() => setIsAssignTemplateModalOpen(false)}
        onSuccess={handleAssignTemplateSuccess}
      />

      <ConfirmationPopup
        visible={confirmationVisible}
        title={confirmationConfig.title}
        message={confirmationConfig.message}
        confirmText={confirmationConfig.confirmText}
        cancelText={confirmationConfig.cancelText}
        confirmButtonType={confirmationConfig.confirmButtonType}
        onConfirm={handleConfirm}
        onCancel={handleConfirmationCancel}
      />
    </div>
  );
};

export default PartnerCompliance;